import { createReduxAsyncThunk } from 'shared/utils';

import { cardsAPI } from 'entities/cards';

import { CARDS_STATE } from '../../constants';

export const getActiveCards = createReduxAsyncThunk(
  `${CARDS_STATE}/getActiveCards`,
  async () => {
    const { data } = await cardsAPI.getActiveCards();
    return data;
  }
);
